export default __webpack_public_path__ + "static/media/41t.cb0e5a41.jpg";